<div class="overlay">
  <div class="overlay__inner">
    <div class="overlay__content">
      <span class="loader"></span>
    </div>
  </div>
</div>
